import type { UseCasePublicSignal } from "@regpulse/contracts";

/**
 * U · Case intelligence — first inputs (RFC-0003 D4 / ADR-0008).
 *
 * The owner's EU automotive enforcement caseset, surfaced as ADVISORY, UNVERIFIED public-case
 * signals (`reviewedBy: null`). These are NOT a declared-scope seed and NEVER enter the board or
 * claim coverage. Per the workflow ("我去搜你核"): the owner runs the live official-source search
 * (KBA / public prosecutor / European Commission press) and VERIFIES each before upgrading
 * (`reviewedBy` set); the `sourceUrl` here is a **candidate official institution root**, not a
 * verified deep link.
 *
 * Red lines honoured:
 *  - No fabricated regulatory literals: summaries carry NO specific monetary figure or date; the
 *    nature is phrased "reported"/"alleged"; the owner adds verified specifics on review.
 *  - Copyright: every summary is authored fresh and neutral — never a reproduction of the owner's
 *    analysis text or of source material.
 */
export const ENFORCEMENT_CASES: UseCasePublicSignal[] = [
  {
    intelType: "enforcement_action",
    summary:
      "Reported diesel-emissions defeat-device enforcement involving Volkswagen by German authorities; specifics reported publicly and pending verification.",
    sourceUrl: "https://www.kba.de/",
    advisoryLabel: "use_case_signal_not_legal_source",
    reviewedBy: null,
  },
  {
    intelType: "enforcement_action",
    summary:
      "Reported NOx-emissions oversight and enforcement proceedings involving Audi; details reported publicly and pending verification.",
    sourceUrl: "https://www.kba.de/",
    advisoryLabel: "use_case_signal_not_legal_source",
    reviewedBy: null,
  },
  {
    intelType: "enforcement_action",
    summary:
      "Reported diesel-emissions enforcement involving Porsche; characterisation reported publicly and pending verification.",
    sourceUrl: "https://www.kba.de/",
    advisoryLabel: "use_case_signal_not_legal_source",
    reviewedBy: null,
  },
  {
    intelType: "enforcement_action",
    summary:
      "Reported diesel-emissions enforcement and vehicle-recall measures involving Mercedes-Benz (Daimler); details reported publicly and pending verification.",
    sourceUrl: "https://www.kba.de/",
    advisoryLabel: "use_case_signal_not_legal_source",
    reviewedBy: null,
  },
  {
    intelType: "enforcement_action",
    summary:
      "Reported diesel-emissions scrutiny involving Opel; characterisation reported publicly and pending verification.",
    sourceUrl: "https://www.kba.de/",
    advisoryLabel: "use_case_signal_not_legal_source",
    reviewedBy: null,
  },
  {
    intelType: "enforcement_action",
    summary:
      "Reported diesel-emissions scrutiny involving BMW; characterisation reported publicly and pending verification.",
    sourceUrl: "https://www.kba.de/",
    advisoryLabel: "use_case_signal_not_legal_source",
    reviewedBy: null,
  },
  {
    intelType: "enforcement_action",
    summary:
      "Reported European Commission antitrust decision concerning alleged coordination on emissions-control technology among several manufacturers; specifics reported publicly and pending verification.",
    sourceUrl: "https://ec.europa.eu/commission/presscorner/",
    advisoryLabel: "use_case_signal_not_legal_source",
    reviewedBy: null,
  },
];
